import React from 'react';

function ResponsiveContainer({ children }) {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-6 md:py-10 lg:py-12">
      {children}
    </div>
  );
}

export default ResponsiveContainer;
